module.exports = __webpack_public_path__ + "img/take-time-to-think.84d4e6ed.png";